import React, { useState, useContext, useEffect, useRef } from 'react'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
// import Heart from '../../components/Images/Heart'
import WhatsappIcon from '../../components/Images/whatsapp'
import { Box, Button } from '../../designSystem'
import {
  Container,
  Title,
  BackButtonContainer,
  ThumbnailImageListContainer,
  ThumbnailImageContainer,
  LectureTitle,
  LectureText,
  ThumbnailImage,
  CourseVedioSection,
  CoursesContainer,
  CourseCard,
  CourseName,
  CourseText,
  VedioContainer,
  LessonVedio,
  LessonTitle,
  LessonDescription,
  FlexContainer,
  // IconContainer,
  // CommentsInfo,
  ViewsWrapper,
  LikesAndShareInfo,
  AddCommentIconContainer,
  SharesIconContainer,
  IconText,
  IconTextDesktop,
  IconContainer,
  Overlay,
  TopSignUpSection,
} from './styles'
import { get, post } from '../../lib/api'
import AlertSnackBar from '../../components/AlertSnackBar'
import {
  getTokenAndUid,
  handleEventLog,
  isMobileOrTablet,
} from '../../lib/utils'
import WriterAcademyComments from './WriterAcademyComments'
import BackButton from '../../components/Images/BackButton'
import WordLimit from './WordLimit'
// import Telegram from '../../components/Images/Telegram'
import Loader from '../../components/Loader'
import Comment2 from '../../components/Images/Comment2'
import PlayIcon from '../../components/Images/PlayIcon'
import SignUpBox from './SignUpBox'

const PageHeader = ({
  activeLesson,
  isMobileView,
  activeCourse,
  handleClickForGoBack,
}) => {
  return (
    <React.Fragment>
      <Box alignItems="center" display="flex">
        {isMobileView && activeLesson && (
          <BackButtonContainer onClick={() => handleClickForGoBack()}>
            <BackButton />
          </BackButtonContainer>
        )}
        {isMobileView && activeCourse && <Title>{activeCourse?.name}</Title>}
        {!isMobileView && <Title>Writer's Academy</Title>}
      </Box>
      <Box variant="hr" />
    </React.Fragment>
  )
}

const WriterAcademyUI = ({ isLoggedIn, user, ...props }) => {
  const [courseMutableList, setCourseMutableList] = useState([])
  const [activeCourse, setactiveCourse] = useState([])
  const [activeLesson, setActiveLesson] = useState(null)
  const [isCommentOpen, setIsCommentOpen] = useState(false)
  const [isCourseLoading, setIsCourseLoading] = useState(false)
  const [totalCommentsCount, setTotalCommentsCount] = useState(null)
  const [isCopied, setIsCopied] = useState(false)
  const [signUpBoxActive, setSignUpBoxActive] = useState(true)
  const { uid } = getTokenAndUid()
  const queryParams = queryString.parse(props?.location?.search)
  const thumbnailContainerRef = useRef()
  const history = useHistory()
  const isPlayedEventSent = useRef(false)
  const isWatched10EventSent = useRef(false)
  const isWatched25EventSent = useRef(false)
  const isWatched50EventSent = useRef(false)
  const isWatched75EventSent = useRef(false)
  const isWatched100EventSent = useRef(false)

  const isMobileView = window.screen.width <= 600
  const handleOnCourseListCard = (id) => {
    props.history.push(`/writers-academy/${id}`)
    setActiveLesson(null)
  }

  useEffect(() => {
    if('IntersectionObserver' in window){
      const observer = new IntersectionObserver(checkImpression, {
        delay: 100,
        trackVisibility: true,
        threshold: 0.8,
      })
      activeCourse?.lessons?.forEach((lesson) => {
        const lessonElement = document.getElementById(lesson.id)
        if (lessonElement) observer.observe(lessonElement)
      })

      const elementsToObserve = document.getElementsByClassName('underObservation')
      for (let i=0; i<elementsToObserve.length; i++) {
        observer.observe(elementsToObserve[i])
      }

      return () => observer.disconnect()
    }
  }, [activeCourse])

  function checkImpression(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isVisible) {
        handleEventLog(
          activeLesson ? 'writer_academy_lesson' : 'writer_academy',
          'impressions',
          {
            entity_id: entry.target.id,
            entity_type: 'lesson',
            module_name: activeLesson ? 'lesson_list' : 'course_list',
          }
        )
      }
    })
  }

  const handleOnClickThumbnail = (lessonData) => {
    const currentLocation = props?.location?.pathname
    props.history.push(currentLocation + '?lesson_id=' + lessonData?.id)
    setActiveLesson({ ...lessonData })
    handleEventLog(
      activeLesson ? 'writer_academy_lesson' : 'writer_academy',
      'show_clicked',
      {
        entity_id: lessonData.id,
        entity_type: 'lesson',
        module_name: activeLesson ? 'lesson_list' : 'course_list',
      }
    )
    handleEventLog('writer_academy_lesson', 'page_load', {
      entity_id: lessonData.id,
      entity_type: 'lesson',
    })
  }
  useEffect(() => {
    if (!activeLesson) return
    const activeNode = document.getElementById(activeLesson?.id)
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    const h =
      activeNode?.offsetTop - thumbnailContainerRef?.current?.offsetTop + 190
    h && thumbnailContainerRef.current.scroll({ top: h, behavior: 'smooth' })
  }, [activeLesson])

  useEffect(() => {
    setIsCourseLoading(true)
    setIsCommentOpen(false)
    get('/academy/courses/?is_novel=1').then((response) => {
      setCourseMutableList([...response])
      setIsCourseLoading(false)
      const course_id = props.match.params.id
      isWatched10EventSent.current = false
      isWatched25EventSent.current = false
      isWatched50EventSent.current = false
      isWatched75EventSent.current = false
      isWatched100EventSent.current = false
      isPlayedEventSent.current = false
      if (course_id) {
        const activecourseIndex = response.findIndex(
          (course) => course?.id === parseInt(course_id)
        )
        if (activecourseIndex >= 0) {
          const { lesson_id } = queryParams
          const activeLesson = [...response][activecourseIndex]?.lessons?.find(
            (lesson) => lesson?.id === parseInt(lesson_id)
          )
          if (activeLesson) {
            setActiveLesson(activeLesson)
          } else {
            setActiveLesson(null)
          }
          setactiveCourse([...response][activecourseIndex])
        } else setactiveCourse([...response][0])
      } else {
        const firstCourseId = [...response][0].id
        props.history.push('/writers-academy/' + firstCourseId)
        setIsCourseLoading(false)
        setactiveCourse([...response][0])
      }
      handleEventLog('writer_academy', 'page_load', {
        entity_id: course_id || [...response][0].id,
        entity_type: 'course',
      })
    })
  }, [props.match.params.id, props.location.search])

  const onShareClick = (lessonId, button) => {
    handleEventLog('writer_academy_lesson', 'button_click', {
      entity_type: 'lesson',
      entity_id: lessonId,
      module_name: button,
    })
    if (!isLoggedIn)
      props.history.push(
        `/login?redirect_to=writers-academy/${activeCourse?.id}?lesson_id=${lessonId}?referrer=writers-academy`
      )
    else {
      const copiedLink = `https://writer.pocketnovel.com/writers-academy/${activeCourse?.id}?lesson_id=${lessonId}?referrer=${uid}?medium=organic?campaign=${lessonId}`
      const str =
        'Hi, Curious about novel writing? \nLearn How to Start Writing \nClick here : ' +
        copiedLink

      if (isMobileOrTablet()) {
        const input = document.body.appendChild(
          document.createElement('TEXTAREA')
        )
        input.value = str
        input.focus({
          preventScroll: true,
        })
        input.select()
        document.execCommand('copy')
        input.parentNode.removeChild(input)
        setIsCopied(true)
        return
      }
      navigator.clipboard.writeText(str).then(() => setIsCopied(true))
    }
  }

  const sendVideoWatchedPixelEvent = (progress) => {
    handleEventLog('writer_academy_lesson', `video_watched_${progress}`, {
      entity_id: activeLesson.id,
      entity_type: 'lesson',
    })
  }
  const handleViewCountOnPlay = () => {
    const postData = {
      academy_lesson_id: activeLesson?.id?.toString(),
    }
    post('/impressions/pocket_writer_impressions?is_novel=1', {
      data: postData,
    })
      .then(() => {
        const updateActiveLesson = { ...activeLesson }
        updateActiveLesson.lesson_views++
        setActiveLesson({ ...updateActiveLesson })
      })
      .catch((err) => {
        throw err
      })
  }

  const prepareVideoEvents = (ct, duration) => {
    if (ct === parseInt(1.0 * duration)) {
      if (!isWatched100EventSent.current) {
        sendVideoWatchedPixelEvent(100)
        isWatched100EventSent.current = true
      }
    }
    if (ct === parseInt(0.75 * duration)) {
      if (!isWatched75EventSent.current) {
        sendVideoWatchedPixelEvent(75)
        isWatched75EventSent.current = true
      }
    }
    if (ct === parseInt(0.5 * duration)) {
      if (!isWatched50EventSent.current) {
        sendVideoWatchedPixelEvent(50)
        isWatched50EventSent.current = true
      }
    }
    if (ct === parseInt(0.25 * duration)) {
      if (!isWatched25EventSent.current) {
        sendVideoWatchedPixelEvent(25)
        isWatched25EventSent.current = true
      }
    }
    if (ct === parseInt(0.1 * duration)) {
      if (!isWatched10EventSent.current) {
        sendVideoWatchedPixelEvent(10)
        isWatched10EventSent.current = true
      }
    }
  }

  const sendVideoPlayedEvent = (active_lesson) => {
    if (!isPlayedEventSent.current) {
      handleViewCountOnPlay()
      handleEventLog('writer_academy_lesson', `video_played`, {
        entity_id: active_lesson.id,
        entity_type: 'lesson',
      })
    }
    isPlayedEventSent.current = true
  }

  const handleTimeUpdate = () => {
    const vid = document.getElementsByTagName('video')[0]
    const ct = parseInt(vid.currentTime)
    const duration = vid.duration
    prepareVideoEvents(ct, duration)
  }

  const viewCount = (lessonViews) => {
    if (!lessonViews) return '0'
    if (lessonViews < 1000) return lessonViews.toString()
    return lessonViews / 1000 + 'K'
  }

  const handleClickForGoBack = () => {
    const { lesson_id } = queryParams
    const course_id = props.match.params.id
    if (lesson_id) {
      setActiveLesson(null)
      props.history.push('/writers-academy/' + course_id)
      return
    }
    history.goBack()
  }

  const handleSignUp = (buttonName) => {
    handleEventLog("writer_academy", "button_click", {
      module_name: buttonName
    })
    props.history.push(
      `/login?redirect_to=writers-academy/${activeCourse?.id}?lesson_id=${activeLesson?.id}?referrer=writers_academy`
    )
  }

  if (isCourseLoading) return <Loader />

  return (
    <>
      {!isCommentOpen && (
        <Box width="100%">
          {!uid && (
            <TopSignUpSection>
              <img src="/images/writer-logo.svg" alt="" />
              <Button 
                onClick={() => handleSignUp('sign_up')}
                className="underObservation"
                id="sign_up"
              >
                SIGN UP
              </Button>
            </TopSignUpSection>
          )}
          <Container>
            <>
              <PageHeader
                activeCourse={activeCourse}
                activeLesson={activeLesson}
                isMobileView={isMobileView}
                handleClickForGoBack={() => handleClickForGoBack()}
              />
              <CoursesContainer isActiveLesson={!activeLesson}>
                {courseMutableList.map((course) => (
                  <CourseCard
                    active={course.id === activeCourse.id}
                    key={course.id}
                    onClick={() => handleOnCourseListCard(course.id)}
                  >
                    <CourseName>{course.course_type} </CourseName>
                    <CourseText>{course.name}</CourseText>
                  </CourseCard>
                ))}
              </CoursesContainer>
              <CourseVedioSection>
                {/* active eposide */}
                {activeLesson && (
                  <>
                    <VedioContainer>
                      <LessonVedio
                        controlsList="nodownload"
                        src={activeLesson?.media_url}
                        width="100%"
                        controls
                        onPlay={() => sendVideoPlayedEvent(activeLesson)}
                        onTimeUpdate={handleTimeUpdate}
                        // autoPlay={true}
                      />
                      <LessonTitle>{activeLesson?.title}</LessonTitle>
                      {isCopied && (
                        <AlertSnackBar
                          text="Copied Successfully"
                          close={() => {
                            setIsCopied(false)
                          }}
                        />
                      )}
                      <FlexContainer>
                        <ViewsWrapper>
                          {activeLesson?.lesson_views || 0}
                          {activeLesson?.lesson_views > 9
                            ? ' views . '
                            : ' view . '}
                          {moment(activeLesson?.create_time).format('ll')}{' '}
                        </ViewsWrapper>
                        {!isMobileView && (
                          <FlexContainer
                            onClick={() =>
                              onShareClick(activeLesson?.id, 'share')
                            }
                          >
                            <WhatsappIcon height="18px" />
                            <IconTextDesktop>Shares</IconTextDesktop>
                          </FlexContainer>
                        )}
                      </FlexContainer>
                      <LessonDescription>
                        {' '}
                        <WordLimit
                          content={activeLesson?.description || ''}
                          limit={150}
                        />
                      </LessonDescription>

                      <IconContainer>
                        <AddCommentIconContainer
                          onClick={() => {
                            setIsCommentOpen(true)
                          }}
                        >
                          <Comment2 />
                          <IconText>
                            {' '}
                            {totalCommentsCount || 'Add '} Comment
                          </IconText>
                        </AddCommentIconContainer>
                        <SharesIconContainer
                          onClick={() =>
                            onShareClick(activeLesson?.id, 'share')
                          }
                        >
                          <WhatsappIcon />
                          <IconText>Shares</IconText>
                        </SharesIconContainer>
                      </IconContainer>
                    </VedioContainer>
                  </>
                )}

                {/* thumbnail gallery */}
                <ThumbnailImageListContainer
                  isScroll={!activeLesson}
                  ref={thumbnailContainerRef}
                >
                  {activeCourse?.lessons &&
                    activeCourse?.lessons.map((lessonData) => (
                      <ThumbnailImageContainer
                        onClick={() => handleOnClickThumbnail(lessonData)}
                        isScroll={!activeLesson}
                        active={
                          activeLesson && activeLesson.id === lessonData.id
                        }
                        key={lessonData.id}
                        id={lessonData.id}
                      >
                        <ThumbnailImage
                          isScroll={!activeLesson}
                          src={lessonData.image_url}
                        />
                        <Overlay
                          isScroll={!activeLesson}
                          isVisible={!isMobileView}
                        >
                          <PlayIcon width={32} height={32} fill={'#FFF'} />
                        </Overlay>
                        <div>
                          <LectureTitle>{lessonData.title}</LectureTitle>
                          <LectureText>
                            {' '}
                            {viewCount(lessonData?.lesson_views)}
                            {lessonData?.lesson_views > 9
                              ? ' views | '
                              : ' view | '}
                          </LectureText>
                          <LectureText>
                            {' '}
                            {moment(lessonData.update_time).format(
                              'DD MMM YYYY'
                            )}{' '}
                          </LectureText>
                        </div>
                      </ThumbnailImageContainer>
                    ))}
                </ThumbnailImageListContainer>
              </CourseVedioSection>
            </>

            {activeLesson && (
              <WriterAcademyComments
                user={user}
                lessonId={activeLesson.id}
                isMobileView={isMobileView}
                isCommentOpen={isCommentOpen}
                setIsCommentOpen={setIsCommentOpen}
                totalCommentsCount={totalCommentsCount}
                setTotalCommentsCount={setTotalCommentsCount}
                handlePostCommentLogoutUser={() => {
                  props.history.push(
                    `/login?redirect_to=writers-academy/${activeCourse?.id}?lesson_id=${activeLesson?.id}?referrer=writers-academy`
                  )
                }}
              />
            )}
          </Container>
          {!uid && signUpBoxActive && 
            <SignUpBox 
              setSignUpBoxActive={setSignUpBoxActive} 
              handleSignUp={handleSignUp} 
          />}
        </Box>
      )}
      {isCommentOpen && activeLesson && (
        <Box width="100%" height="100%">
          <WriterAcademyComments
            user={user}
            lessonId={activeLesson.id}
            isMobileView={isMobileView}
            isCommentOpen={isCommentOpen}
            setIsCommentOpen={setIsCommentOpen}
            totalCommentsCount={totalCommentsCount}
            setTotalCommentsCount={setTotalCommentsCount}
            handlePostCommentLogoutUser={() => {
              props.history.push(
                `/login?redirect_to=writers-academy/${activeCourse?.id}?lesson_id=${activeLesson?.id}?referrer=writers-academy`
              )
            }}
          />
        </Box>
      )}
    </>
  )
}

export default WriterAcademyUI
